export class CandidateProfile {
    constructor() {
        this.id = null;
        this.name;
        this.firstName;
        this.lastName;
        this.title;
        this.companyName;
        this.educations = [];
        this.experiences = [];
        this.certifications = [];
        this.compensations = [];
        this.technicalSkills = [];
        this.softSkills = [];
        this.others = [];
    }
}
//# sourceMappingURL=candidateProfile.js.map